import { render, staticRenderFns } from "./StagingCriterionFormStepTwo.vue?vue&type=template&id=3479cea8"
import script from "./StagingCriterionFormStepTwo.vue?vue&type=script&lang=ts"
export * from "./StagingCriterionFormStepTwo.vue?vue&type=script&lang=ts"
import style0 from "./StagingCriterionFormStepTwo.vue?vue&type=style&index=0&id=3479cea8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports